import {
  Box,
  Button,
  CircularProgress,
  // Dialog,
  // DialogActions,
  // DialogContent,
  // DialogTitle,
  Divider,
  Drawer,
  IconButton,
  SwipeableDrawer,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { GiftBrand } from "../models/GiftBrand";
import { useAppDispatch, useAppSelector } from "../hooks/hooks";
import { setSelectGiftCardsDrawerOpen } from "../redux/giftBrandsSlice";
import CloseIcon from "@mui/icons-material/Close";
import { setCurrentNavigationView } from "../redux/uiSlice";

interface SelectGiftsProps {
  onSelect: (brand: GiftBrand) => void;
}

const SelectGiftsDialog: React.FC<SelectGiftsProps> = ({ onSelect }) => {
  const [loading, setLoading] = useState(false);
  const { selectGiftCardsDrawerOpen } = useAppSelector(
    (state) => state.giftBrands
  );
  const { myPurchases } = useAppSelector((state) => state.giftBrands);
  const dispatch = useAppDispatch();

  const handleSubmit = async () => {
    setLoading(true);
  };

  const scrollableBoxStyles = {
    maxHeight: "20vh",
    overflowY: "auto",
    scrollbarWidth: "none", // For Firefox
    "&::-webkit-scrollbar": {
      display: "none", // For Chrome, Safari, and Opera
    },
  };

  return (
    <Drawer
      anchor="bottom"
      open={selectGiftCardsDrawerOpen}
      onClose={() => dispatch(setSelectGiftCardsDrawerOpen(false))}
      sx={{
        "& .MuiDrawer-paper": {
          width: { xs: "100%", sm: 500 },
          margin: "0 auto",
          borderTopLeftRadius: 12,
          borderTopRightRadius: 12,
          height: "auto",
          maxHeight: "60vh",
          boxSizing: "border-box",
          px: 2,
          pb: 2,
          pt: 1,
        },
      }}
    >
      <>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 1,
          }}
        >
          <Typography variant="subtitle1">
            Select Gift Card Attachment
          </Typography>
          <IconButton
            onClick={() => dispatch(setSelectGiftCardsDrawerOpen(false))}
          >
            <CloseIcon />
          </IconButton>
        </Box>
        <Divider sx={{ mb: 2 }} />

        {myPurchases.length === 0 && (
          <Box
            sx={{
              textAlign: "center",
              py: 4,
              minHeight: "200px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Typography variant="body1">No Gift Cards Available</Typography>

            <Button
              variant="contained"
              onClick={() => {
                dispatch(setCurrentNavigationView("market"));
                dispatch(setSelectGiftCardsDrawerOpen(false));
              }}
              sx={{ mt: 2 }}
            >
              Buy Gift Cards
            </Button>
          </Box>
        )}

        <Box
          sx={{
            ...scrollableBoxStyles,
            pt: 2,
            display: "grid",
            gridTemplateColumns: "repeat(1, 1fr)",
            gap: 2,
            justifyItems: "center",
          }}
        >
          {myPurchases.map((brand) => (
            <Box
              key={brand.productId}
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                padding: 2,
                border: "1px solid #ccc",
                borderRadius: 1,
                width: "100%",
                gap: 1.5,
                "&:hover": { boxShadow: 1 },
              }}
            >
              <img
                src={brand.productImage}
                alt={brand.brandName}
                style={{
                  width: "100%",
                  height: 150,
                  objectFit: "contain",
                  borderRadius: 4,
                }}
              />
              <Box
                sx={{
                  textAlign: "center",
                  flexGrow: 1,
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <span>{brand.brandName}</span>
              </Box>
              <Button
                variant="contained"
                color="primary"
                onClick={() => onSelect(brand)}
                fullWidth
              >
                Select
              </Button>
            </Box>
          ))}
        </Box>
      </>

      {/* <Box sx={{ p: 2, textAlign: "center" }}>
        <Button onClick={onClose} disabled={loading}>
          Cancel
        </Button>
        <Button
          onClick={handleSubmit}
          color="primary"
          variant="contained"
          disabled={loading}
        >
          {loading ? <CircularProgress size={24} /> : "Select Gift Card"}
        </Button>
      </Box> */}
    </Drawer>
  );
};

export default SelectGiftsDialog;
